import { render, staticRenderFns } from "./IssuedVisaFooter.vue?vue&type=template&id=343af20b&"
import script from "./IssuedVisaFooter.vue?vue&type=script&lang=js&"
export * from "./IssuedVisaFooter.vue?vue&type=script&lang=js&"
import style0 from "./IssuedVisaFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports